import React from "react"
import { connect } from "react-redux"

import DeputyLogo from "./assets/deputy-logo.svg"
const apiURL = `https://api.buddy.hr/v1`

const DeputySettings = ({ deputyConnected, deputyNeedsReconnection }) => {
  return (
    <div className="col-sm-12 integration-row">
      <div className="col-sm-3">
        <img src={DeputyLogo} width="40px" />
        <span style={{ paddingLeft: 20, fontSize: 16 }}>Deputy</span>
      </div>
      <div className="col-sm-9">
        {deputyConnected ?
          <>
            {deputyNeedsReconnection ?
              <a className="btn btn-primary pull-right" style={{ marginTop: 2 }} href={`https://once.deputy.com/my/oauth/login?client_id=3e1bae19831c0d9bf81b8c9b674f2f72b2683311&redirect_uri=${apiURL}/deputy/auth&response_type=code&scope=longlife_refresh_token`}>
                Reconnect
              </a>

            :
              <button className="btn btn-default pull-right" style={{ marginTop: 2 }}>
                Connected
              </button>
            }
          </>
        :
          <a className="btn btn-primary pull-right" style={{ marginTop: 2 }} href={`https://once.deputy.com/my/oauth/login?client_id=3e1bae19831c0d9bf81b8c9b674f2f72b2683311&redirect_uri=${apiURL}/deputy/auth&response_type=code&scope=longlife_refresh_token`}>
            Connect
          </a>
        }
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    deputyConnected: state.deputy?.connected,
    deputyNeedsReconnection: state.deputy?.needsReconnection,
  }
}

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(DeputySettings)
